import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=6336442b&"
import script from "./regist.vue?vue&type=script&lang=js&"
export * from "./regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports